import { ALL } from "./constants";
import { useSelectedGroup } from "./context";

export function useSelectAllGroup() {
  const { setSelectedGroup } = useSelectedGroup();
  const selectAllGroup = () => {
    setSelectedGroup(ALL);
  };

  return {
    selectAllGroup,
  };
}
